import { KontableComponent } from './../../../../modules/UIKit/components/kontable/kontable.component';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Supplier } from '../../../../models/supplier.model';
import { DataTableService } from '../../../../modules/UIKit/components/dataTable/dataTable.service';
import { DataTableCustomButton } from '../../../../modules/UIKit/components/dataTable/dataTableCustomButton.interface';
import { DataTableField } from '../../../../modules/UIKit/components/dataTable/dataTableField.interface';
import { SupplierService } from '../../../../services/supplier/supplier.service';

@Component({
    selector: 'app-suppliers-list',
    templateUrl: './supplier-list.component.html'
})
export class SupplierListComponent implements OnInit {

  @Output() customButtonBrand = new EventEmitter();
  @Output() customButtonCertification = new EventEmitter();
  private titles: DataTableField[];
  private customButtons: DataTableCustomButton[];
  private activeView = 'list';
  modalTitle = '';
  labels = {};
  newDatatableAvailable: boolean = false;
  paginationType = KontableComponent.ServerPagination;

  constructor(
    public svc: SupplierService,
    private srvDataTable: DataTableService,
    private translate: TranslateService) {

      this.translate.get([
        'common.code',
        'common.entity_name',
        'common.supplier_brand',
        'common.supplier_certifications',
      ]).subscribe((res) => {
        this.titles = [
          { id: 'id', label: '#' },
          { id: 'code', label: res['common.code'] },
          { id: 'entity_name', label: res['common.entity_name'] },
        ];

        this.customButtons = [
          {
            callbackname: 'brands',
            icon: null,
            isAlwaysEnabled: false,
            label: res['common.supplier_brand']
          },
          {
            callbackname: 'certifications',
            icon: null,
            isAlwaysEnabled: false,
            label: res['common.supplier_certifications']
          },
        ]
      });
  }

  ngOnInit() {

    this.translate.get([
      'supplierList.add_title',
      'supplierList.edit_title'
    ]).subscribe((res) => {
      this.labels['add_title'] = res['supplierList.add_title'];
      this.labels['edit_title'] = res['supplierList.edit_title'];
    });

    this.reloadList();
  }

  reloadList() {
    this.activeView = 'list';
    //this.svc.getList().subscribe();
    this.newDatatableAvailable = true
  }

  showAddOrEditDialog(data): void {
    this.modalTitle = data == null ? this.labels['add_title'] : this.labels['edit_title'];
    this.svc.editing = data == null ? new Supplier() : data;
  }

  delete (entry): void {
    this.svc.delete(entry.id).subscribe(() => {
      this.reloadList()
    });
  }

  recover (entry): void {
    this.svc.recover(entry.id).subscribe(() => {
      this.reloadList()
    });
  }

  onAddElement(entry): void {
    this.svc.post(entry).subscribe(() => {
      this.srvDataTable.get('dt_suppliers').showDetail = false;
      this.svc.editing = null;
      this.reloadList()
    });
  }

  onUpdateElement(entry): void {
    this.svc.put(this.svc.editing.id, entry).subscribe(() => {
      this.srvDataTable.get('dt_suppliers').showDetail = false;
      this.svc.editing = null;
      this.reloadList()
      }
    )
  }

  onDialogHide () {
    this.svc.editing = null;
  }

  goToBrand (supplier: Supplier) {
    this.customButtonBrand.emit (supplier);
  }

  goToCertification (supplier: Supplier) {
    this.customButtonCertification.emit (supplier);
  }

}



// WEBPACK FOOTER //
// ./src/app/views/administration/supplier/supplier-list/supplier-list.component.ts